export const toMonetaryValue = (number: number) => number.toFixed(2)
